<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div class="m3 p3 white-bg">
        <div class="mb2 mt-1 ml-1">
          <span class="bold">{{ getReferencelabel("MY_PERSONAL_INFORMATION") }}</span>
        </div>
        <div>
          <div class="col-12 flex flex-column items-center justify-center">
            <div class="col-12 sm-col-6 md-col-4 my1 flex items-center justify-center">
              <UserPhoto style="width: 125px; height: 125px; min-width: 125px; min-height: 125px;" />
            </div>
            <div class="col-12 my1 flex items-center justify-center">
              <div class="flex flex-column my-profile-text">
                <div class="">
                  <p class="center h3n bold profile-name blue m0">{{ user.firstname }} {{ user.lastname }}</p>
                  <p class="center h3n semi-bold profile-name blue m0">{{ genderVocabulary(user.gender) }} {{ user.birth_date }}</p>
                  <p class="center h3n profile-name blue m0">{{ user.email }}</p>
                </div>
                <div class="py2">
                  <p class="center h3n bold m0">{{ streetInfo }}</p>
                  <p v-if="user.mobilephone" class="center h3n bold m0">{{ getReferencelabel("TEL") }} {{ user.mobilephone }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center col-12">
            <Button :reference="getReferencelabel('EDIT_PERSONAL_DETAILS')" class="center mt2 col-12 sm-col-6 md-col-4 lg-col-4" btn-color="blue" :action="editProfile" />
          </div>
          <a class="h5n mt2 underline flex justify-center pointer" @click="logout"> {{ getReferencelabel("LOGOUT") }}</a>
        </div>
      </div>
      <div>
        <GenerateForm :form="emergencyContactForm" :data="emergencyContactData" :save-action="updateUserData" :form-name="getReferencelabel('CONTACT_IN_CASE_OF_EMEGENCY')" />
      </div>
      <!-- <p class="h5n pb3 semi-bold center">{{ user.email }}</p> --> <!-- Disabled for now -->
    </template>
    <router-view v-else />
  </div>
</template>

<script>

import { computed, ref, reactive, getCurrentInstance } from 'vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router';
import { useStore } from 'vuex';

import UserPhoto from '@/components/elements/UserPhoto';
import Button from '@/components/elements/Button';
import GenerateForm from '@/components/common/GenerateForm';

import { updateUser } from '@/mixins/requests';
import { genderVocabulary, getReferencelabel, isInImpersonateModeNotification, routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: {
    Button,
    UserPhoto,
    GenerateForm
  },
  setup () {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    function logout () {
      store.commit('setImpersonateData', null);
      window.location.href = '/af/logout';
    }

    const user = computed(() => store.state.user);

    const streetInfo = computed(() => {
      let streetText = user.value.address2 || '';

      // Build the string backwards
      if (user.value.town) {
        streetText = `${user.value.town}, ${streetText}`;
      }

      if (user.value.zip_code) {
        streetText = `${user.value.zip_code}, ${streetText}`;
      }

      if (user.value.street_name) {
        streetText = `${user.value.street_name}, ${streetText}`;
      }

      if (user.value.street_number) {
        streetText = `${user.value.street_number}, ${streetText}`;
      }

      return streetText;
    });

    function editProfile () {
      router.push({ name: 'EditMyProfile' });
    }

    function editEmergencyConctact () {
      router.push({ name: 'EditMyEmergencyContact' });
    }

    // Emergency Contact
    const emergencyContactForm = reactive([
      [
        { reference: 'EMERGENCY_CONTACT_FIRST_NAME', id: 'emergency_contact.firstname', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: 'FIRST_NAME' },
        { reference: 'EMERGENCY_CONTACT_LAST_NAME', id: 'emergency_contact.lastname', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: 'LAST_NAME' }
      ],
      [
        { reference: 'EMERGENCY_CONTACT_EMAIL', id: 'emergency_contact.email', type: 'email', class: 'col-12 sm-col-6', required: false, placeholder: '' },
        { reference: 'EMERGENCY_CONTACT_PHONE_NUMBER', id: 'emergency_contact.telephone', type: 'em_tel', class: 'col-12 sm-col-6', required: false, placeholder: 'MOBILE_PLACEHOLDER' }
      ]
    ]);

    const emergencyContactData = ref(JSON.parse(JSON.stringify(store.state.user)));

    async function updateUserData () {
      if (isInImpersonateModeNotification()) {
        return;
      }

      store.commit('setLoading', true);
      await updateUser(emergencyContactData.value);

      store.commit('setLoading', false);
    }

    // To reset the emergency value when moving between pages
    onBeforeRouteUpdate(() => {
      emergencyContactData.value = JSON.parse(JSON.stringify(store.state.user));
    });

    return { logout, editProfile, editEmergencyConctact, user, streetInfo, genderVocabulary, route, getReferencelabel, emergencyContactForm, emergencyContactData, updateUserData, routeMatchesComponent };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

@media (max-width: 40em) {
  .my-profile-text {
    text-align: center;
  }
}

</style>
